import { Repository } from '@basehub/data/replicache/index'
import { getRepoSlugWithoutCollisions } from '@basehub/utils/case/index'

export function _getRepoSlugForTitle({
  title,
  id,
  repos,
}: Pick<Repository, 'title' | 'id'> & {
  repos: Pick<Repository, 'title' | 'id' | 'slug'>[]
}) {
  const slug = getRepoSlugWithoutCollisions(id, title, repos, true) as string

  let failedWith = ''

  if (
    repos.some((r) => {
      if (r.id === id) return false
      if (r.title === title) {
        failedWith = 'title'
        return true
      } else if (r.slug === slug) {
        failedWith = 'slug'
        return true
      }
    })
  ) {
    throw new Error(
      `Duplicate error: Repository ${failedWith} "${
        { title, slug }[failedWith]
      }" already exists.`
    )
  }

  return slug
}
